import script from "./BudgetGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetGrid.vue?vue&type=script&setup=true&lang=js"

import "./BudgetGrid.vue?vue&type=style&index=0&id=e17f0a56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e17f0a56"]])

export default __exports__